@for (key of formatStyleKeys([]); track key) {
  <dl>
    @if (!isFunction($any(emptyStyle)[key])) {
      <dt>{{ key }}:</dt>
    }
    <dd>
      @if (isNumber($any(emptyStyle)[key])) {
        <input type="number" [max]="maxNumber($any(formatStyle), key)" [min]="minNumber($any(formatStyle), key)"
          [ngModel]="$any(formatStyle)[key]" (ngModelChange)="updateRawType($event, [key])" />
      } @else {
        @if (isBoolean($any(emptyStyle)[key])) {
          <input type="checkbox" [ngModel]="$any(formatStyle)[key]" (ngModelChange)="updateRawType($event, [key])" />
        } @else {
          @if (isString($any(emptyStyle)[key])) {
            <input type="text" [ngModel]="$any(formatStyle)[key]" (ngModelChange)="updateRawType($event, [key])" />
          } @else {
            @if (isEnum($any(emptyStyle)[key])) {
              <select [ngModel]="getEnum($any(formatStyle)[key])" (ngModelChange)="updateEnum($event, [key])">
                @for (style of allEnums($any(emptyStyle)[key]); track style) {
                  <option [ngValue]="style">
                    {{ style }}
                  </option>
                }
              </select>
            } @else {
              @if (isUndefined($any(emptyStyle)[key])) {
                <input type="checkbox" (change)="onUndefinedCheckboxChange($event, inputElement.value, [key])" />
                <input #inputElement type="number" [disabled]="$any(formatStyle)[key] === undefined"
                  (input)="onUndefinedInputChange(inputElement.value, [key])" />
              } @else {
                @if (isStringList($any(emptyStyle)[key])) {
                  <textarea class="textarea_field" rows="5"
                  (input)="onStringList($event, [key])">{{ stringListToTextArea($any(formatStyle)[key]) }}</textarea>
                } @else {
                  @if (isList($any(emptyStyle)[key])) {
                    <span>Size:</span>
                    <input max="0xFFFFFFFF" min="0" type="number"
                      [ngModel]="$any(formatStyle)[key].size()" (ngModelChange)="resizeList($event, [key])" />
                    @for (index of [].constructor($any(formatStyle)[key].size()); track $index; let i = $index) {
                      <dl>
                        <dt>Item {{ i }}</dt>
                        <dd>
                          @for (subkey of formatStyleKeys([key, i]); track subkey) {
                            <dl>
                              @if (!isFunction($any(formatStyle)[key].get(i)[subkey])) {
                                <dt>{{ subkey }}:</dt>
                              }
                              <dd>
                                @if (isNumber($any(formatStyle)[key].get(i)[subkey])) {
                                  <input type="number" [max]="maxNumber($any(formatStyle)[key].get(i), subkey)"
                                    [min]="minNumber($any(formatStyle)[key].get(i), subkey)"
                                    [ngModel]="$any(formatStyle)[key].get(i)[subkey]"
                                    (ngModelChange)="updateRawType($event, [key, i, subkey])" />
                                } @else {
                                  @if (isBoolean($any(formatStyle)[key].get(i)[subkey])) {
                                    <input type="checkbox" [ngModel]="$any(formatStyle)[key].get(i)[subkey]"
                                      (ngModelChange)="updateRawType($event, [key, i, subkey])" />
                                  } @else {
                                    @if (isString($any(formatStyle)[key].get(i)[subkey])) {
                                      <input type="text" [ngModel]="$any(formatStyle)[key].get(i)[subkey]"
                                        (ngModelChange)="updateRawType($event, [key, i, subkey])" />
                                    } @else {
                                      @if (isEnum($any(formatStyle)[key].get(i)[subkey])) {
                                        <select [ngModel]="getEnum($any(formatStyle)[key].get(i)[subkey])"
                                          (ngModelChange)="updateEnum($event, [key, i, subkey])">
                                          @for (style of allEnums($any(formatStyle)[key].get(i)[subkey]); track style) {
                                            <option [ngValue]="style">
                                              {{ style }}
                                            </option>
                                          }
                                        </select>
                                      } @else {
                                        @if (isUndefined($any(formatStyle)[key].get(i)[subkey])) {
                                          <input type="checkbox"
                                            (change)="onUndefinedCheckboxChange($event, inputElement.value, [key, i, subkey])" />
                                          <input #inputElement type="number" [disabled]="$any(formatStyle)[key].get(i)[subkey] === undefined"
                                            (input)="onUndefinedInputChange(inputElement.value, [key, i, subkey])" />
                                        } @else {
                                          @if (isStringList($any(formatStyle)[key].get(i)[subkey])) {
                                            <textarea class="textarea_field" rows="5"
                                            (input)="onStringList($event, [key, i, subkey])">{{ stringListToTextArea($any(formatStyle)[key].get(i)[subkey]) }}</textarea>
                                          } @else {
                                            @if (!isFunction($any(formatStyle)[key].get(i)[subkey])) {
                                              <span>Not implemented KiK: {{ $any(formatStyle)[key].get(i)[subkey] }}</span>
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              </dd>
                            </dl>
                          }
                        </dd>
                      </dl>
                    }
                  } @else {
                    @if (isMiscStruct($any(emptyStyle)[key])) {
                      @for (subkey of formatStyleKeys([key]); track subkey) {
                        <dl>
                          @if (!isFunction($any(emptyStyle)[key][subkey])) {
                            <dt>{{ subkey }}:</dt>
                          }
                          <dd>
                            @if (isNumber($any(emptyStyle)[key][subkey])) {
                              <input type="number" [max]="maxNumber($any(formatStyle)[key], subkey)"
                                [min]="minNumber($any(formatStyle)[key], subkey)" [ngModel]="$any(formatStyle)[key][subkey]"
                                (ngModelChange)="updateRawType($event, [key, subkey])" />
                            } @else {
                              @if (isBoolean($any(emptyStyle)[key][subkey])) {
                                <input type="checkbox" [ngModel]="$any(formatStyle)[key][subkey]"
                                  (ngModelChange)="updateRawType($event, [key, subkey])" />
                              } @else {
                                @if (isString($any(emptyStyle)[key][subkey])) {
                                  <input type="text" [ngModel]="$any(formatStyle)[key][subkey]"
                                    (ngModelChange)="updateRawType($event, [key, subkey])" />
                                } @else {
                                  @if (isEnum($any(emptyStyle)[key][subkey])) {
                                    <select [ngModel]="getEnum($any(formatStyle)[key][subkey])"
                                      (ngModelChange)="updateEnum($event, [key, subkey])">
                                      @for (style of allEnums($any(emptyStyle)[key][subkey]); track style) {
                                        <option [ngValue]="style">
                                          {{ style }}
                                        </option>
                                      }
                                    </select>
                                  } @else {
                                    @if (isUndefined($any(emptyStyle)[key][subkey])) {
                                      <input type="checkbox"
                                        (change)="onUndefinedCheckboxChange($event, inputElement.value, [key, subkey])" />
                                      <input #inputElement type="number" [disabled]="$any(formatStyle)[key][subkey] === undefined"
                                        (input)="onUndefinedInputChange(inputElement.value, [key, subkey])" />
                                    } @else {
                                      @if (isStringList($any(emptyStyle)[key][subkey])) {
                                        <textarea class="textarea_field" rows="5"
                                        (input)="onStringList($event, [key, subkey])">{{ stringListToTextArea($any(formatStyle)[key][subkey]) }}</textarea>
                                      } @else {
                                        @if (isList($any(emptyStyle)[key][subkey])) {
                                          <span>Size:</span>
                                          <input max="0xFFFFFFFF" min="0"
                                            type="number" [ngModel]="$any(formatStyle)[key][subkey].size()" (ngModelChange)="resizeList($event, [key, subkey])" />
                                          @for (index of [].constructor($any(formatStyle)[key][subkey].size()); track $index; let i = $index) {
                                            <dl>
                                              <dt>Item {{ i }}</dt>
                                              <dd>
                                                @for (subkey2 of formatStyleKeys([key, subkey, i]); track subkey2) {
                                                  <dl>
                                                    @if (!isFunction($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                      <dt>{{ subkey2 }}:</dt>
                                                    }
                                                    <dd>
                                                      @if (isNumber($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                        <input type="number" [max]="maxNumber($any(formatStyle)[key][subkey].get(i), subkey2)"
                                                          [min]="minNumber($any(formatStyle)[key][subkey].get(i), subkey2)"
                                                          [ngModel]="$any(formatStyle)[key][subkey].get(i)[subkey2]"
                                                          (ngModelChange)="updateRawType($event, [key, subkey, i, subkey2])" />
                                                      } @else {
                                                        @if (isBoolean($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                          <input type="checkbox" [ngModel]="$any(formatStyle)[key][subkey].get(i)[subkey2]"
                                                            (ngModelChange)="updateRawType($event, [key, subkey, i, subkey2])" />
                                                        } @else {
                                                          @if (isString($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                            <input type="text" [ngModel]="$any(formatStyle)[key][subkey].get(i)[subkey2]"
                                                              (ngModelChange)="updateRawType($event, [key, subkey, i, subkey2])" />
                                                          } @else {
                                                            @if (isEnum($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                              <select [ngModel]="getEnum($any(formatStyle)[key][subkey].get(i)[subkey2])"
                                                                (ngModelChange)="updateEnum($event, [key, subkey, i, subkey2])">
                                                                @for (style of allEnums($any(formatStyle)[subkey].get(i)[subkey2]); track style) {
                                                                  <option
                                                                    [ngValue]="style">
                                                                    {{ style }}
                                                                  </option>
                                                                }
                                                              </select>
                                                            } @else {
                                                              @if (isUndefined($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                                <input type="checkbox"
                                                                  (change)="onUndefinedCheckboxChange($event, inputElement.value, [key, subkey, i, subkey2])" />
                                                                <input #inputElement type="number"
                                                                  [disabled]="$any(formatStyle)[key][subkey].get(i)[subkey2] === undefined"
                                                                  (input)="onUndefinedInputChange(inputElement.value, [key, subkey, i, subkey2])" />
                                                              } @else {
                                                                @if (isStringList($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                                  <textarea class="textarea_field" rows="5"
                                                                  (input)="onStringList($event, [key, subkey, i, subkey2])">{{ stringListToTextArea($any(formatStyle)[key][subkey].get(i)[subkey2]) }}</textarea>
                                                                } @else {
                                                                  @if (!isFunction($any(formatStyle)[key][subkey].get(i)[subkey2])) {
                                                                    <span>Not implemented KKiK: {{ $any(formatStyle)[key][subkey].get(i)[subkey2] }}</span>
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    </dd>
                                                  </dl>
                                                }
                                              </dd>
                                            </dl>
                                          }
                                        } @else {
                                          @if (!isFunction($any(formatStyle)[key][subkey])) {
                                            <span>Not implemented KK: {{ $any(formatStyle)[key][subkey] }}</span>
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          </dd>
                        </dl>
                      }
                    } @else {
                      @if (!isFunction($any(formatStyle)[key])) {
                        <span>Not implemented K: {{ $any(formatStyle)[key] }}</span>
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    </dd>
  </dl>
}